(function () {
  'use strict';

  var body = document.querySelector('[data-pwr-legal-body]');
  var listNodes = document.querySelectorAll('[data-pwr-legal-toc-list]');
  if (!body || !listNodes.length) return;

  var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
  if (!headings.length) return;

  var usedIds = {};
  headings.forEach(function (heading, index) {
    if (!heading.id) {
      var base = (heading.textContent || 'section')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '') || 'section-' + index;
      var id = base;
      var suffix = 1;
      while (usedIds[id]) {
        id = base + '-' + suffix;
        suffix += 1;
      }
      usedIds[id] = true;
      heading.id = id;
    }
  });

  var links = [];

  listNodes.forEach(function (listNode) {
    var fragment = document.createDocumentFragment();
    headings.forEach(function (heading) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.className = 'pwr-legal-toc__link';
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      item.appendChild(link);
      fragment.appendChild(item);
      links.push({ heading: heading, link: link });
    });
    listNode.appendChild(fragment);
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (pair) {
          var isActive = pair.heading === entry.target;
          pair.link.classList.toggle('is-active', isActive);
        });
      });
    },
    { rootMargin: '-120px 0px -70% 0px', threshold: 0 }
  );

  headings.forEach(function (heading) {
    observer.observe(heading);
  });
})();
